(() => {
  if (customElements.get("headline-banner")) return;

  class HeadlineBanner extends HTMLElement {
    constructor() {
      super();
      this.cleanup = [];
      this.wrapper = null;
      this.spotlight = null;
      this.desktopQuery = null;

      this.handleMouseMove = (event) => this.onMouseMove(event);
      this.handleMouseLeave = () => this.hideSpotlight();
      this.handleViewportChange = (event) => this.onViewportChange(event);
    }

    connectedCallback() {
      this.wrapper = this.querySelector("[data-headline-banner-wrapper]");
      this.spotlight = this.querySelector("[data-headline-banner-spotlight]");
      if (!this.wrapper || !this.spotlight) return;

      this.desktopQuery = window.matchMedia("(min-width: 750px)");

      this.addListener(this.wrapper, "mousemove", this.handleMouseMove);
      this.addListener(this.wrapper, "mouseenter", this.handleMouseMove);
      this.addListener(this.wrapper, "mouseleave", this.handleMouseLeave);
      this.addMediaListener();
    }

    disconnectedCallback() {
      this.cleanup.forEach((remove) => remove());
      this.cleanup = [];
      this.wrapper = null;
      this.spotlight = null;
      this.desktopQuery = null;
    }

    addListener(el, event, handler, options) {
      if (!el) return;
      el.addEventListener(event, handler, options);
      this.cleanup.push(() => el.removeEventListener(event, handler, options));
    }

    addMediaListener() {
      if (!this.desktopQuery) return;

      if (this.desktopQuery.addEventListener) {
        this.desktopQuery.addEventListener("change", this.handleViewportChange);
        this.cleanup.push(() =>
          this.desktopQuery.removeEventListener(
            "change",
            this.handleViewportChange,
          ),
        );
      } else {
        this.desktopQuery.addListener(this.handleViewportChange);
        this.cleanup.push(() =>
          this.desktopQuery.removeListener(this.handleViewportChange),
        );
      }
    }

    onMouseMove(event) {
      if (!this.desktopQuery || !this.desktopQuery.matches) return;
      if (!this.wrapper || !this.spotlight) return;

      const rect = this.wrapper.getBoundingClientRect();
      const x = event.clientX - rect.left - 300;
      const y = event.clientY - rect.top - 300;

      this.spotlight.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      this.spotlight.style.opacity = "0.4";
    }

    onViewportChange(event) {
      if (!event.matches) this.hideSpotlight();
    }

    hideSpotlight() {
      if (!this.spotlight) return;
      this.spotlight.style.opacity = "0";
    }
  }

  customElements.define("headline-banner", HeadlineBanner);
})();

